module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_FR-438fa5c9942f6c572a3259ff10e28f87.svg";